import type { HaEntityState } from "@/lib/api";

/**
 * Whether the hub can actually read the ventilation unit right now.
 *
 * The connect checklist used to tick "Ventilation online" the moment the
 * Modbus entry loaded. An entry loads, and its climate entity reads `auto`,
 * whether or not the unit behind it has answered a single register. Beta Test
 * House 20's resident was offered TURBO 26 seconds after the connector came
 * online, before the hub had one reading, and the command failed. The backend
 * marks each entity `live` from its real readings; the unit counts as readable
 * once its climate entity is.
 */
export function unitReadable(entities: ReadonlyArray<HaEntityState> | undefined): boolean {
  return (entities ?? []).some((e) => e.entity_id.startsWith("climate.") && e.live === true);
}
